import { getApiHeaders } from '../utils/apiHeaders';

const API_BASE_URL = process.env.REACT_APP_TRAVEL_API_BASE_URL;

export type InsuranceSearchParams = {
  planCategory: number;
  planType: number;
  planCoverage: number;
  travelStartDate: string;
  travelEndDate: string;
  noOfPax: number;
  paxAge: number[];
};

export const searchInsurance = async (params: InsuranceSearchParams): Promise<any[]> => {
  const response = await fetch(`${API_BASE_URL}/insurance/search`, {
    method: 'POST',
    headers: getApiHeaders('json'),
    body: JSON.stringify(params),
  });

  if (!response.ok) {
    throw new Error(`Failed to search insurance: ${response.statusText}`);
  }

  const data = await response.json();
  if (Array.isArray(data)) return data;
  if (Array.isArray(data?.items)) return data.items;
  if (Array.isArray(data?.data)) return data.data;
  return [];
};
